"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBoolean = void 0;
const react_1 = require("react");
const useBoolean = (initialValue) => {
    const [isTrue, setIsTrue] = (0, react_1.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : false);
    (0, react_1.useEffect)(() => {
        setIsTrue(initialValue !== null && initialValue !== void 0 ? initialValue : false);
    }, [initialValue]);
    const setTrue = (0, react_1.useCallback)(() => {
        setIsTrue(true);
    }, []);
    const setFalse = (0, react_1.useCallback)(() => {
        setIsTrue(false);
    }, []);
    const toggle = (0, react_1.useCallback)(() => {
        setIsTrue(prevIsTrue => !prevIsTrue);
    }, []);
    const set = (0, react_1.useCallback)(setIsTrue, [setIsTrue]);
    return (0, react_1.useMemo)(() => ({
        isTrue,
        isFalse: !isTrue,
        setTrue,
        setFalse,
        toggle,
        set
    }), [isTrue, setFalse, setTrue, toggle, set]);
};
exports.useBoolean = useBoolean;
//# sourceMappingURL=use-boolean.js.map